export default "__VITE_ASSET__fUeFaTmSEDxVNjIWtJl6uA__"